module.exports = __webpack_public_path__ + "static/media/Share-tb-ico.02839bd3.svg";